import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  CardContent,
  Collapse,
  IconButton,
  Divider,
} from "@mui/material";
import {
  useResentWorkshopEmailNewletterMutation,
  useGetNewletterQuery,
  useCreateNewsletterEmailRecordMutation,
  useGetNewsletterEmailRecordQuery,
  useGetAllWorkshopNewsLetterQuery,
  useGetAllWorkshopQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import {
  INewsletter,
  INewsletterGmail,
  INewsletterGmailHistory,
  IWorkShop,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/ResentEmail";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import Pagination from "../../../Components/Pagination";
import { Link } from "react-router-dom";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import dayjs, { Dayjs } from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FcOk, FcCancel } from "react-icons/fc";
import { SlLike } from "react-icons/sl";
import { SlDislike } from "react-icons/sl";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MailOffIcon from "@mui/icons-material/MailOutline";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ReplayIcon from "@mui/icons-material/Replay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }: any) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const Index = () => {
  const { id: newsletterId } = useParams<{ id: string }>();
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedCoursing, setSelectedCoursing] = useState<INewsletter | null>(
    null
  );
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<INewsletterGmailHistory | null>(null);
  const [expandedTemplateId, setExpandedTemplateId] = useState<string | null>(
    null
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const {
    data: nesLetterData,
    isLoading: newsletterIsLoading,
    isError: newLetterEmailIsError,
  } = useGetAllWorkshopNewsLetterQuery({
    id: String(newsletterId),
    searchText: "",
  });

  const { data, isLoading, isError, refetch } = useGetNewletterQuery({
    searchText: currentSearchQuery,
    isActive: null,
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const [newEmail, { isLoading: createEmaliRecordLoading }] =
    useCreateNewsletterEmailRecordMutation();

  const { data: emailRecodData, isLoading: emailRecordIsLoading } =
    useGetNewsletterEmailRecordQuery({
      searchText: "",
      id: "",
    });

  const { data: customerDate, isLoading: customerIsLoading } =
    useGetAllWorkshopQuery({
      searchText: "",
      staffId: "",
      clientId: "",
      id: "",
      fromDate: null,
      toDate: null,
      categoryId: "",
      multi_final_status_filter: [],
    });

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDeletePopup = (coursing: INewsletterGmailHistory) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const newsLetterEmail = useMemo(() => {
    if (
      nesLetterData &&
      Array.isArray(nesLetterData.data) &&
      nesLetterData.data.length > 0
    ) {
      return nesLetterData.data[0] as INewsletterGmail;
    }
    return null;
  }, [nesLetterData]);

  const emailRecordList = useMemo(() => {
    return emailRecodData?.data as INewsletter[];
  }, [emailRecodData?.data]);

  const customerList = useMemo(() => {
    return customerDate?.data as IWorkShop[];
  }, [customerDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const cutomerMap = useMemo(() => {
    const map = new Map();
    customerList?.forEach((category) => {
      map.set(category.id, toProperCase(category.name || ""));
    });
    return map;
  }, [customerList]);

  const customerMap = useMemo(() => {
    const map = new Map<number, { fullName: string; email: string }>();

    customerList?.forEach((customer) => {
      map.set(customer.id, {
        fullName:
          toProperCase(customer.name || ""),
        email: customer.email || "",
      });
    });

    return map;
  }, [customerList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.staff}`);
    });
    return map;
  }, [userList]);

  const [deleteCategory] = useResentWorkshopEmailNewletterMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resend");
    }
  };

  if (isLoading || newsletterIsLoading || userIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card} sx={{ minHeight: 400 }}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={3}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>E-mail</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={3} p={2}>
              <Grid item xs={12} md={12} lg={12}>
                <Card variant="outlined" className={classes.card}>
                  <CardContent sx={{ cursor: "pointer" }}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item>
                        <Grid container spacing={1} direction="column">
                          <Grid item>
                            <Typography variant="subtitle1" fontWeight={600}>
                              From: {newsLetterEmail?.fromEmail}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      {newsLetterEmail?.created_at &&
                        newsLetterEmail?.created_by && (
                          <Grid item>
                            <Grid container spacing={1} direction="column">
                              <Grid item>
                                <Typography
                                  variant="subtitle1"
                                  color="textSecondary"
                                >
                                  {`${
                                    dayjs(newsLetterEmail?.created_at).format(
                                      "MMM-D, YYYY hh:mm A"
                                    ) || ""
                                  } | ${userMap.get(
                                    newsLetterEmail?.created_by
                                  )}`}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item xs={12} sm={8}>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          noWrap
                        >
                          Subject: {newsLetterEmail?.subject}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm="auto">
                        {newsLetterEmail?.status === "Success" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <CheckCircleIcon sx={{ color: "green" }} />
                            </Grid>
                            <Grid item>
                              <Typography
                                variant="body2"
                                sx={{ color: "green" }}
                              >
                                Sent Successfully - Delivered to all clients
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : newsLetterEmail?.status === "Partial Failure" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <WarningAmberIcon sx={{ color: "orange" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="body2" color="warning.main">
                                Partial Failure - Some emails failed to send
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : newsLetterEmail?.status === "No Email Found" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <MailOffIcon sx={{ color: "orange" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="body2" color="error">
                                No Email Found - Newsletter could not be sent
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : newsLetterEmail?.status === "Partial - No Email" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <ReportProblemIcon sx={{ color: "orange" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="body2" color="warning.main">
                                Partial Delivery - Some clients don't have an
                                email
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : newsLetterEmail?.status === "Failed" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <CancelIcon sx={{ color: "red" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="body2" color="error">
                                Failed to Send
                              </Typography>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item>
                              <CancelIcon sx={{ color: "red" }} />
                            </Grid>
                            <Grid item>
                              <Typography variant="body2" color="error">
                                {newsLetterEmail?.status || "Failed to Send"}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>

                  <Divider />
                  <CardContent>
                    <Typography
                      component="div"
                      dangerouslySetInnerHTML={{
                        __html: newsLetterEmail?.message || "",
                      }}
                    />
                  </CardContent>
                  {newsLetterEmail?.attachments &&
                    newsLetterEmail?.attachments !== "[]" && (
                      <CardContent sx={{ pt: 2 }}>
                        <Typography
                          variant="subtitle2"
                          fontWeight={600}
                          gutterBottom
                        >
                          Attachments:
                        </Typography>
                        <Grid container spacing={2}>
                          {(() => {
                            let attachments: string[] = [];
                            try {
                              attachments = JSON.parse(
                                newsLetterEmail.attachments
                              );
                            } catch (e) {
                              attachments = [];
                            }

                            return attachments.map((file, index) => {
                              const isImage =
                                /\.(jpeg|jpg|png|gif|webp)$/i.test(file);
                              const isPdf = /\.pdf$/i.test(file);
                              const isVideo = /\.mp4$/i.test(file);

                              return (
                                <Grid item key={index}>
                                  <a
                                    href={file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      cursor: "pointer",
                                      // display: "inline-block",
                                    }}
                                  >
                                    {isImage && (
                                      <img
                                        src={file}
                                        alt={`attachment-${index}`}
                                        style={{
                                          width: 200,
                                          height: 200,
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    )}
                                    {isPdf && (
                                      <div
                                        style={{
                                          border: "1px solid #ccc",
                                          width: 200,
                                          height: 200,
                                        }}
                                      >
                                        <object
                                          data={file}
                                          type="application/pdf"
                                          style={{
                                            // border: "1px solid #ccc",
                                            width: 200,
                                            height: 150,
                                          }}
                                        ></object>
                                        <p>
                                          <a
                                            href={file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Click here to download
                                          </a>
                                        </p>
                                      </div>
                                    )}
                                    {isVideo && (
                                      <video
                                        controls
                                        style={{
                                          width: 200,
                                          height: 200,
                                          border: "1px solid #ccc",
                                        }}
                                      >
                                        <source src={file} type="video/mp4" />
                                        Your browser does not support the video
                                        tag.
                                      </video>
                                    )}
                                    {!isImage && !isPdf && !isVideo && (
                                      <a
                                        href={file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none" }}
                                      >
                                        <Typography color="primary">
                                          Download File {index + 1}
                                        </Typography>
                                      </a>
                                    )}
                                  </a>
                                </Grid>
                              );
                            });
                          })()}
                        </Grid>
                      </CardContent>
                    )}
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        {newsLetterEmail &&
          newsLetterEmail.history_record &&
          newsLetterEmail.history_record.length > 0 && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Typography className={classes.cardTitle}>
                          Workshop email List
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Email</strong>
                          </TableCell>
                          {/* <TableCell className={classes.tablheader}>
                            <strong>Create At</strong>
                          </TableCell> */}
                          <TableCell className={classes.tablheader}>
                            <strong>Status</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Actions</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {newLetterEmailIsError ||
                        newsLetterEmail.history_record.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {newLetterEmailIsError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          newsLetterEmail?.history_record.map(
                            (row: INewsletterGmailHistory, index) => {
                              const customer = customerMap.get(row.workshopMemberId);
                              return (
                                <TableRow
                                  key={row.id}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Link
                                      to={`/workshop/history/${row.workshopMemberId}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      {" "}
                                      <Typography
                                        className={classes.nameTableList}
                                      >
                                        {customer ? `${customer.fullName}` : ""}
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ color: "#1976d2" }}
                                          />
                                        </span>
                                      </Typography>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {row.toEmail
                                      ? `${row.toEmail}`
                                      : `${customer?.email}`}
                                  </TableCell>
                                  {/* <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {dayjs(row.created_at).format(
                                    "MMM-D, YYYY hh:mm A"
                                  ) || ""}
                                </TableCell> */}
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {row.status === "Sent" ? (
                                      <FcOk size={30} />
                                    ) : (
                                      // <FcCancel size={30} />
                                      <CancelIcon
                                        sx={{ color: "red", fontSize: 32 }}
                                      />
                                    )}
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid item>
                                        {row.status !== "Sent" && (
                                          <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            startIcon={<ReplayIcon />}
                                            onClick={() =>
                                              handleOpenDeletePopup(row)
                                            }
                                            disabled={!customer?.email}
                                          >
                                            Resent
                                          </Button>
                                        )}
                                        {row.status === "No email found" &&
                                          !customer?.email && (
                                            <div>
                                              <Typography
                                                sx={{
                                                  fontStyle: "italic",
                                                  color: "#a75252",
                                                  fontWeight: 550,
                                                }}
                                                color="textSecondary"
                                                variant="body2"
                                              >
                                                -- No email found for client --
                                              </Typography>
                                            </div>
                                          )}
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {coursingToDelete && (
                    <DeletePopup
                      open={openDeleteCategory}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(coursingToDelete.id.toString());
                      }}
                      title="Resent E-mail"
                      content={`Are you sure you want to resent e-mail "${coursingToDelete.toEmail}"?`}
                    />
                  )}
                </Grid>
              </Card>
            </Grid>
          )}
      </Grid>
    </div>
  );
};

export default Index;
